class PhysicalCashCountController {
    /*@ngInject*/
    constructor(Auth, $state, User, UsersService, DateUtil, $translate, $q, Modal, BranchService, SetupService, PhysicalCashCountService, $rootScope) {
        this.BranchService = BranchService;
        this.UsersService = UsersService;
        this.DateUtil = DateUtil;
        this.Modal = Modal;
        this.SetupService = SetupService
        this.User = User;
        this.Auth = Auth;
        this.$translate = $translate;
        this.$q = $q;
        this.$state = $state;
        this.PhysicalCashCountService = PhysicalCashCountService;
        this.$rootScope = $rootScope;

        this.model = {
            currentBranch: User.getUser().branchId,
            cashCountObj: {},
            branchCurrentVaultDate: '',
            loading: false,
            physicalCashCountRecord: [],
            commitRecords: false,
            fundingSourceData: [],
            acl: {},
            hasACL: {},
            permissionKey: 'branch_mgmt_physical_cash_count',
            balanceCheckIds: [],
            currency: 'USD',
            loggedInUser: this.User.getUser().id,
            isSupervisor: false,
            isPriorVaultDate: false
        };

        this.accountType = [
            {
                lable: "Regular",
                value: "regular"
            },
            {
                lable: "Emergency",
                value: "emergency"
            }
        ]
        this.$rootScope.$broadcast('routeChange', '/app/branch-management/physical-cash-count');
    }

    $onInit() {
        this.model.loading = true;
        this.$q.all([
            this.SetupService.get(this.model.currentBranch),
            this.UsersService.checkSupervisor(this.model.loggedInUser)
        ]).then((data) => {
                const setupData = data[0];
                const userDetails = data[1];

                this.model.branchCurrentVaultDate = this.DateUtil.convertToDate(setupData.currentVaultDate);
                this.model.date = this.model.branchCurrentVaultDate;
                this.model.userInfo = userDetails;
                this.model.isSupervisor = userDetails.supervisor;
                this.model.maxVaultDate = {
                    minDate: this.model.date,
                    maxDate: this.model.branchCurrentVaultDate
                    // maxDate: moment(this.model.branchCurrentVaultDate).add(0, 'days').toDate()
                }
                this.getFundingSource()
                    .then(() => {
                        this.getRequirementOrBalanceCount();
                        this.loadPermission();
                    })
                    .catch((err) => {
                        console.log(err);
                        this.Modal.errorModal(err.data.message);
                    });
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                // this.model.loading = false;
            })
    }

    getFundingSource() {
        return this.PhysicalCashCountService.getFundingSource(this.model.currentBranch)
            .then((data) => {
                this.model.fundingSource = data.results;
                this.model.fundingSourceData = this.model.fundingSource.map(fc => {
                    return {fundingSourceId: fc.fundingSourceId, name: fc.sourceName, currencyId: fc.currencyId}
                });
            })
    }

    getRequirementOrBalanceCount() {
        this.model.loading = true;
        const formattedDate = moment(this.model.date).format('YYYY-MM-DD');

        let currentVaultDate = new Date(this.model.branchCurrentVaultDate).getTime();
        let selectedDate = new Date(this.model.date).getTime();
        this.model.isPriorVaultDate = moment(selectedDate).isBefore(currentVaultDate);

        this.PhysicalCashCountService.findRequirementOrBalanceCount(this.model.currentBranch, this.model.fundingSourceData, formattedDate)
            .then((results) => {
                this.model.physicalCashCountData = results;
                this.model.denominations = results.denominations;
                this.model.fundingSourceStatus = results.fundingSourceStatus;
                this.defaultCashCountData();
                this.shouldShowLabels();
            })
            .catch((err) => {
                console.log(err);
                this.Modal.errorModal(err.data.message);
            })
            .finally(() => {
                this.model.balanceCheckIds = [];
                this.model.loading = false;
            })
    }

    confirmSupervisor(stat) {
        const entryType = stat === 'edit' ? 'edit-physical-cash-count' : 'physical-cash-count-commit';
        if (this.model.userInfo && this.model.userInfo.supervisor) {
            this.Modal.confirmSupervisor(entryType, null, ({ modal, supId }) => {
                this.verifyLedgerBalance(supId, stat);
                modal.close();
            }, ({ modal }) => {
                modal.close();
            })
        }
        else {
            this.verifyLedgerBalance(this.model.loggedInUser, stat);
        }
    }

    commit(userId) {
        const formattedDate = moment(this.model.date).format('YYYY-MM-DD');

        let data = this.model.physicalCashCountRecord.filter((d) => {
            return d.status === 'Pending' && d.denominations && d.denominations.length > 0
        })
        
        this.model.commitRecords = true;
        return this.PhysicalCashCountService.commitPhysicalCashCount(data, this.model.currentBranch, userId, this.model.currency, null, formattedDate)
            .then(() => {
                this.getRequirementOrBalanceCount();
            })
            .catch((err) => {
                console.log(err);
                this.Modal.errorModal(err.data.message);
            })
            .finally(() => {
                this.model.commitRecords = false;
            })
    }

    verifyLedgerBalance(userId, stat) {
        const data = this.model.physicalCashCountRecord.map((d) => {
            return {
                denominations: d.denominations,
                fundingSourceId: d.fundingSourceId,
                branchId: this.model.currentBranch
            }
        });

        this.isCheckForVariance = true;
        this.PhysicalCashCountService.checkForVariance(data)
            .then((res) => {
                if (res && res.hasVariance) {
                    this.Modal.confirm({
                        header: this.$translate.instant('common.confirm_title'),
                        message: this.$translate.instant('The current count will produce a variance. Are you sure you want to commit with a variance?'),
                        callback: (({
                            modal,
                            $scope
                        }) => {
                            this.isCommit = true;
                            if (stat === 'edit') {
                                this.editPhysicalCashCount(userId)
                            }
                            else {
                                this.commit(userId);
                            }
                            modal.close();
                        }),
                        negative: (({
                            modal,
                        }) => {
                            this.isCommit = false;
                            modal.close();
                        }),
                        type: 'danger'
                    })
                }
                else {
                    if (stat === 'edit') {
                        this.editPhysicalCashCount(userId)
                    }
                    else {
                        this.commit(userId);
                    }
                }
            })
            .catch((err) => {
                console.log(err);
                this.Modal.errorModal(err.data.message);
            })
            .finally(() => {
                this.isCheckForVariance = false;
            })
    }

    calculateTotalAmount(index) {
        let totalDenominationsAmount = 0;
        this.model.physicalCashCountRecord[index].denominations.forEach((denom) => {
            totalDenominationsAmount = totalDenominationsAmount + (denom.amount || 0);
        })
        this.model.physicalCashCountRecord[index].totalAmount = totalDenominationsAmount;
    }

    calculateAccountBalance(index, accountType, amount) {
        this.model.physicalCashCountRecord[index].enteredRegularAmount = 0;
        this.model.physicalCashCountRecord[index].enteredEmergencyAmount = 0;

        this.model.physicalCashCountRecord[index].denominations.forEach((denom) => {
            if (denom.account === 'regular') {
                this.model.physicalCashCountRecord[index].enteredRegularAmount += denom.amount || 0;
            }
            else if (denom.account === 'emergency') {
                this.model.physicalCashCountRecord[index].enteredEmergencyAmount += denom.amount || 0;
            }

            if (this.model.physicalCashCountRecord[index].enteredRegularAmount > this.model.physicalCashCountRecord[index].regularBalance) {
                this.model.physicalCashCountRecord[index].regularBalanceError = "Regular Balance Is Out Of Bulk Cash";

            } else {
                this.model.physicalCashCountRecord[index].regularBalanceError = null;
            }

            if (this.model.physicalCashCountRecord[index].enteredEmergencyAmount > this.model.physicalCashCountRecord[index].emergencyBalance) {
                this.model.physicalCashCountRecord[index].emergencyBalanceError = "Emergency Balance Is Out Of Bulk Cash";

            } else {
                this.model.physicalCashCountRecord[index].emergencyBalanceError = null;
            };

            if (this.model.physicalCashCountRecord[index].regularBalanceError && this.model.physicalCashCountRecord[index].emergencyBalanceError) {
                this.model.physicalCashCountRecord[index].commonBalanceError = "Regular & Emergency Balance Is Out Of Bulk Cash";
            } else this.model.physicalCashCountRecord[index].commonBalanceError = null;
        })
    }

    validBalanceDisabled() {
        let disableButton = this.model.physicalCashCountRecord.map((data) => {
            let validate = false;
            if (data.regularBalanceError || data.emergencyBalanceError) {
                validate = true;
                data.validBalanceErr = validate;
                return validate;
            }

            if (data.regularBalanceError === null || data.emergencyBalanceError === null) {
                validate = false;
                data.validBalanceErr = validate;
                return validate;
            }
            return validate;
        })

        if (disableButton.indexOf(true) >= 0) return true;
        else return false;
    }

    defaultCashCountData() {
        let denom = [];
        this.model.physicalCashCountRecord = [];
        this.model.fundingSource.forEach((fs, index) => {
            let fundingSourceObj = _.find(this.model.fundingSourceStatus, { 'fundingSourceId': fs.fundingSourceId });

            this.model.physicalCashCountRecord[index] = {
                denominations: [],
                fundingSourceId: fs.fundingSourceId,
                fundingSourceName: fs.sourceName,
                // vaultDate: this.model.branchCurrentVaultDate,
                status: fundingSourceObj.status,
                finishedByUserId: fundingSourceObj.finishedByUserId,
                finishedByUserName: fundingSourceObj.finishedByUserName,
                finishedAt: fundingSourceObj.finishedAt,
                totalAmount: 0,
                balanceCheckId: fundingSourceObj.balanceCheckId,
                edit: false,
                regularBalance: fundingSourceObj.regularLedgerBalance,
                emergencyBalance: fundingSourceObj.emergencyLedgerBalance,
                enteredRegularAmount: 0,
                enteredEmergencyAmount: 0,
                approved: fundingSourceObj.approved,
                approvedByUserId: fundingSourceObj.approvedByUserId,
                approvedByUserName: fundingSourceObj.approvedByUserName,
                approvedAt: fundingSourceObj.approvedAt
            }
        })

        this.model.denominations.forEach((d) => {
            denom.push({
                cashBalance: d.cashBalance,
                denominationId: d.denominationId,
                faceValue: d.denominationFaceValue,
                amount: d.amountCounted >= 0 ? d.amountCounted : null,
                account: d.account,
                status: d.status,
                fundingSourceId: d.fundingSourceId,
                denominationCoinFlag: d.denominationCoinFlag,
                sortOrder: d.shipTypeSortOrder,
                isValid: false,
                amountVariance: d.amountVariance
            })
        })

        let denomGroup = _.groupBy(denom, function (entry) { return entry.status && entry.fundingSourceId })
        this.model.physicalCashCountRecord.forEach((record) => {
            if (record.status == 'Completed') {
                if (denomGroup[record.fundingSourceId]){
                    denomGroup[record.fundingSourceId].forEach((d) => {
                        record.totalAmount += d.amount;
                        d.isValid = true;
                    });
                }
            }
            record.denominations = denomGroup[record.fundingSourceId] || [];
        })

        this.model.physicalCashCountRecord.forEach((d) => {
            d.denominations = _.sortBy(d.denominations, ['faceValue', 'asc']);
        })
    }

    validateDenomAmount(fundingSourceIndex, denominationIndex) {
        let disableButton = this.model.physicalCashCountRecord[fundingSourceIndex].denominations.map((data) => {
            if (
                (data.amount === undefined || data.amount === "" || data.amount === null) ||
                (this.isFloat(data.faceValue) ? (Math.round(data.amount % data.faceValue) > 0) : (data.amount % data.faceValue > 0))
               ) return false;
            else return true;
        })

        if (disableButton[denominationIndex] === true) this.model.physicalCashCountRecord[fundingSourceIndex].denominations[denominationIndex].isValid = true;
        else this.model.physicalCashCountRecord[fundingSourceIndex].denominations[denominationIndex].isValid = false;
    }

    commitDisabled() {
        let disableButton = this.model.physicalCashCountRecord ? this.model.physicalCashCountRecord.map((data) => {
            let validate = true;
            if (data && data.denominations) {
                data.denominations.map(denom => validate = validate && denom.isValid)
            }
            return validate;
        }) : [];
        if (disableButton.indexOf(false) >= 0) return true;
        else return false;
    }

    hideCommitBtn() {
        let currentVaultDate = new Date(this.model.branchCurrentVaultDate).getTime();
        let selectedDate = new Date(this.model.date).getTime();
        let isPastVaultDate = moment(selectedDate).isBefore(currentVaultDate);

        let hideButton = this.model.physicalCashCountRecord.map((data) => {
            let validate = true;
            validate = validate && (data.status === 'Completed' || isPastVaultDate)
            return validate;
        })
        if (hideButton.indexOf(false) >= 0) return false;
        else return true;
    }

    shouldShowLabels() {
        const map = {};
        this.model.physicalCashCountData.denominations.forEach(item => {
            const { fundingSourceId, account } = item;

            if (!map[fundingSourceId]) {
                map[fundingSourceId] = {
                    regular: [],
                    emergency: []
                };
            }

            if (map[fundingSourceId][account]) {
                map[fundingSourceId][account].push(item);
            }
        });

        const result = {};

        Object.keys(map).forEach(fsId => {
            const sourceData = map[fsId];

            result[fsId] = {
                regular: {
                    count: sourceData.regular.length,
                    hasDenominations: sourceData.regular.length > 0,
                },
                emergency: {
                    count: sourceData.emergency.length,
                    hasDenominations: sourceData.emergency.length > 0,
                }
            };
        });

        this.model.fundingSourceDenoms = result;
    };

    print(fundingSourceId) {
        const physicalCashCountData = this.model.physicalCashCountRecord.filter((data) => {
            return data.status === 'Completed' && data.fundingSourceId === fundingSourceId
        })

        let url = this.$state.href('printPhysicalCashCount');
        window.w = window.open(url, '_blank');
        window.w.printData = {
            physicalCashCountData: physicalCashCountData,
            branch: this.model.currentBranch,
            isSupervisor: this.model.isSupervisor,
            denomsForAccount: this.model.fundingSourceDenoms[fundingSourceId]
        }
    }

    loadPermission() {
        this.model.acl[this.model.permissionKey] = this.User.getACL(this.model.permissionKey);
        this.model.hasACL[this.model.permissionKey] = {};
        this.model.acl[this.model.permissionKey].forEach((permission) => {
            this.model.hasACL[this.model.permissionKey][permission] = true;
        });

        if (this.model.hasACL[this.model.permissionKey]['edit']) {
            this.model.maxVaultDate.minDate = null;
        }
    }

    edit(balanceCheckObj) {
        balanceCheckObj.edit = true;
        balanceCheckObj.status = 'Pending';
        balanceCheckObj.denominations.forEach((denom) => denom.status = 'Pending');
        this.model.balanceCheckIds.push(balanceCheckObj.balanceCheckId);

        const fundingSourceIndex = _.findIndex(this.model.fundingSource, { fundingSourceId: balanceCheckObj.fundingSourceId });

        if (fundingSourceIndex !== undefined) {
            this.model.physicalCashCountRecord[fundingSourceIndex].denominations.map((data, denominationIndex) => {
                if (data.amount === undefined || 
                    data.amount === '' || 
                    this.isFloat(data.faceValue) ? (Math.round(data.amount % data.faceValue) > 0) : (data.amount % data.faceValue > 0)) 
                {
                    this.model.physicalCashCountRecord[fundingSourceIndex].denominations[denominationIndex].isValid = false;
                }
                else this.model.physicalCashCountRecord[fundingSourceIndex].denominations[denominationIndex].isValid = true;
            })
        }
    }

    showCancelEditButton() {
        let validateBtn = this.model.physicalCashCountRecord.map((data) => {
            let validate = true;
            validate = validate && data.edit
            return validate;
        })

        if (validateBtn.indexOf(true) >= 0) return true;
        else return false;
    }

    cancelEdit() {
        this.defaultCashCountData();
        this.model.balanceCheckIds = [];
    }

    editPhysicalCashCount(supId) {
        const formattedDate = moment(this.model.date).format('YYYY-MM-DD');

        let data = this.model.physicalCashCountRecord.filter((d) => {
            return d.status === 'Pending' && d.denominations && d.denominations.length > 0
        })

        this.model.commitRecords = true;
        return this.PhysicalCashCountService.editPhysicalCashCount(data, this.model.balanceCheckIds, supId, this.model.currentBranch, this.model.currency, formattedDate)
            .then(() => {
                this.getRequirementOrBalanceCount();
            })
            .catch((err) => {
                console.log(err);
                this.Modal.errorModal(err.data.message);
            })
            .finally(() => {
                this.model.commitRecords = false;
                this.model.balanceCheckIds = [];
            })
    }

    approveWithSupervisor(data) {
        if (this.model.userInfo && this.model.userInfo.supervisor) {
            this.Modal.confirmSupervisor('approve-physical-cash-count', null, ({ modal, supId }) => {
                data.userId = supId;
                this.approvePhysicalCashCount(data);
                modal.close();
            }, ({ modal }) => {
                modal.close();
            })
        }
        else {
            data.userId = this.model.loggedInUser;
            this.approvePhysicalCashCount(data);
        }
    }

    approvePhysicalCashCount(data) {
        const totalVariance = data.denominations.reduce((sum, denom) => sum + (denom.amount - denom.cashBalance), 0);
        data.totalVariance = Number(totalVariance).toFixed(2);
        this.isApprovePhysicalCashCount = true;

        if (totalVariance !== 0) {
            this.Modal.confirm({
                header: this.$translate.instant('common.confirm_title'),
                message: this.$translate.instant('Are you sure you want to approve a cash count with a variance?'),
                callback: ({ modal }) => {
                    this.approve(data, modal);
                },
                negative: ({ modal }) => {
                    modal.close();
                    this.isApprovePhysicalCashCount = false;
                },
                type: 'success'
            })
        }
        else {
            this.approve(data);
        }
    }

    approve(data, modal) {
        const formattedDate = moment(this.model.date).format('YYYY-MM-DD'), denoms = [];
        data.denominations.forEach((d) => {
            denoms.push({ denominationId: d.denominationId, amount: d.amount, account: d.account, variance: d.amountVariance });
        });

        this.PhysicalCashCountService.approvePhysicalCashCount(formattedDate, data.fundingSourceId, this.model.currentBranch, data.userId, data.totalAmount, data.totalVariance, denoms)
            .then(() => {
                this.getRequirementOrBalanceCount();
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    return this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                if (modal) modal.close();
                this.isApprovePhysicalCashCount = false;
            })
    }

    isFloat(n) {
        return n % 1 !== 0;
    }

    amountVariance(amount) {
        let num = Number(amount);
        return num.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }
}

export default PhysicalCashCountController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/physical_cash_count/physical_cash_count.controller.js